import { Text, VStack, Image, Spacer, Flex } from '@chakra-ui/react';
import moment from 'moment-timezone';

import logo from '../../Assets/Logos/logoL.webp';

const Footer = () => {
    return (
        <Flex px="10" mt='4' mb={['275px','275px','170px','170px','170px']}>
            <Image src={logo} alt="logo digicel" width='14%' my="auto" h='auto' />
            <Spacer />
            <VStack
                spacing={0}
                align='stretch'
                p="2"
            >
                <Text fontSize="sm" color="black" className="General" textAlign="left">
                    Copyright &copy; {moment().format('YYYY')} - Be Call Group
                </Text>
                <Text fontSize="xs" color="black" className="General" textAlign="left">
                    All right reserved
                </Text>
            </VStack>
        </Flex>
    )
}

export default Footer